import React from 'react';
import PropTypes from 'prop-types';
import { withApollo } from 'react-apollo';

import { QueryComponent } from 'GraphQL';
import { getMyMockExamList } from 'GraphQL/query/MockExam.query';

import MockExamOverviewView from './MockExamOverview.view';
import { useMyMockWishDepartmentData } from './hooks';

const MockExamOverview = ({ menus, client, ...restProps }) => {
  const { departmentData, studentProfileData } = useMyMockWishDepartmentData(client);
  return (
    <QueryComponent query={getMyMockExamList}>
      {data => {
        const { myMockExamList } = data || {};
        const { examRounds } = myMockExamList || {};
        return (
          <MockExamOverviewView
            menus={menus}
            examRounds={examRounds}
            studentData={studentProfileData}
            myMockWishDepartmentData={departmentData}
            {...restProps}
          />
        );
      }}
    </QueryComponent>
  );
};

MockExamOverview.propTypes = {
  menus: PropTypes.array,
};

export default withApollo(MockExamOverview);
